<template>
	<div
		class="bookmarks-shortcut-skeleton"
		:aria-label="$t('spa__general.loading')"
	>
		<div class="bookmarks-shortcut-skeleton__row">
			<SuiSkeleton width="2rem" is-circle />
			<SuiSkeleton
				width="50%"
				class="bookmarks-shortcut-skeleton__item"
			/>
		</div>

		<div class="bookmarks-shortcut-skeleton__row">
			<SuiSkeleton width="2rem" is-circle />
			<SuiSkeleton
				width="90%"
				class="bookmarks-shortcut-skeleton__item"
			/>
		</div>

		<div class="bookmarks-shortcut-skeleton__row">
			<SuiSkeleton width="2rem" is-circle />
			<SuiSkeleton
				width="50%"
				class="bookmarks-shortcut-skeleton__item"
			/>
		</div>

		<div class="bookmarks-shortcut-skeleton__row">
			<SuiSkeleton width="2rem" is-circle />
			<SuiSkeleton
				width="70%"
				class="bookmarks-shortcut-skeleton__item"
			/>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { SuiSkeleton } from '@developers/scoro-ui';

export default defineComponent({
	components: {
		SuiSkeleton,
	},
});
</script>

<style lang="scss" scoped>
.bookmarks-shortcut-skeleton {
	padding: 2.5rem 6rem 4.5rem 3rem;

	&__row {
		display: flex;
		align-items: center;

		&:not(:last-child) {
			margin-bottom: 5rem;
		}
	}

	&__item {
		margin-left: 1rem;
		height: 1.5rem;
	}
}
</style>
